<template>
  <div theme="localInsightLightTheme">
    <v-dialog
      :max-width="maxWidth"
      v-model="showDynamicDialog"
      activator="parent"
      :persistent="persistent"
      :fullscreen="fullscreen"
    >
      <v-card class="pa-0 h-100" rounded="0">
        <!-- title bar -->
        <v-card-title
          ref="testref"
          :style="
            'background-color: ' +
            this.$store.state.config.siteConfig.toolbar_colour
          "
          class="text-h6 pl-1 d-flex align-center dynamicTextColour"
          :class="hideCloseButton ? 'pl-5' : 'pl-1'"
        >
          <v-btn
            v-if="!hideCloseButton"
            icon="mdi-close"
            variant="text"
            tile
            @click="
              showDynamicDialog = false;
              $emit('dialogCancel');
            "
            aria-label="Close dialog panel"
            class="mr-4"
          />
          <slot name="title">Dialog Title</slot>
        </v-card-title>
        <!-- content -->
        <v-card-text
          :style="{
            height: height,
            maxHeight: maxHeight,
            minHeight: minHeight,
            overflow: 'auto',
          }"
          :class="contentClass"
        >
          <slot name="content">Dialog content</slot>
        </v-card-text>
        <v-divider></v-divider>
        <!-- footer -->
        <v-card-actions v-if="!hideFooter">
          <slot name="footer">
            <v-btn
              v-if="!cancelBtnHidden"
              ref="cancelBtn"
              :color="cancelBtnColor"
              tile
              :prepend-icon="cancelPrependIcon"
              @click="
                showDynamicDialog = false;
                $emit('dialogCancel');
              "
              :variant="cancelBtnVariant"
              :title="cancelBtnLabel"
              :aria-label="cancelBtnLabel"
            >
              <div>
                <slot name="cancelBtnTitle">CANCEL</slot>
              </div>
            </v-btn>
            <v-spacer v-if="!okBtnHidden" />
            <v-btn
              v-if="!okBtnHidden"
              ref="okBtn"
              :color="okBtnColor"
              tile
              :prepend-icon="okPrependIcon"
              :variant="okBtnVariant"
              :title="okBtnLabel"
              :aria-label="okBtnLabel"
              @click="$emit('dialogOk')"
              :disabled="okBtnDisabled"
              :loading="okBtnSpinner"
            >
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
              <div>
                <slot name="okBtnTitle">OK</slot>
              </div>
            </v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DynamicDialog",
  data: () => ({
    okBtnLabel: "",
    cancelBtnLabel: "",
  }),
  emits: [
    "update:showDynamicDialog",
    "update:show",
    "dialogOk",
    "dialogCancel",
  ],
  props: {
    /**
     * visibility of dialog passed from parent
     */
    show: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: undefined,
      required: false,
    },
    minHeight: {
      type: String,
      default: undefined,
      required: false,
    },
    height: {
      type: String,
      default: undefined,
      required: false,
    },
    maxHeight: {
      type: String,
      default: undefined,
      required: false,
    },
    okBtnDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    okBtnSpinner: {
      type: Boolean,
      required: false,
      default: false,
    },
    okBtnColor: {
      type: String,
      default: "success",
      required: false,
    },
    okBtnVariant: {
      type: String,
      default: "elevated",
      required: false,
    },
    okPrependIcon: {
      type: String,
      default: null,
      required: false,
    },
    cancelBtnColor: {
      type: String,
      default: "error",
      required: false,
    },
    cancelBtnHidden: {
      type: [Boolean, String],
      required: false,
      default: false,
      disabled: [Boolean, String],
    },
    cancelBtnVariant: {
      type: String,
      default: "elevated",
      required: false,
    },
    contentClass: {
      type: String,
      default: "pa-6",
      required: false,
    },
    cancelPrependIcon: {
      type: String,
      default: null,
      required: false,
    },
    hideCloseButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    okBtnHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {},
  computed: {
    showDynamicDialog: {
      get: function () {
        //get parent v-model state
        return this.show;
      },
      set: function (newVal) {
        //update parent v-model
        this.$emit("update:show", newVal);

        // custom model if there is one
        this.$emit("update:showDynamicDialog", newVal);
      },
    },
  },
  watch: {
    //watch visibility of dialog component
    show(visible) {
      if (visible) {
        //dialog is visible
        this.$nextTick(() => {
          //update button titles/aria labels to match dynamic button content
          if (!this.okBtnHidden) {
            this.okBtnLabel = this.$refs.okBtn?.$el.textContent.toLowerCase();
          }
          if (!this.cancelBtnHidden) {
            this.cancelBtnLabel =
              this.$refs.cancelBtn?.$el.textContent.toLowerCase();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
